export default "__VITE_ASSET__DIpIlZF7__"